module.exports = __webpack_public_path__ + "img/11.e03b28c.png";